import React from 'react';
import Audio from "./Audio.tsx";

interface AudiosProps {
    offset: number;
    iterObject: any[];
    editedContent: any;
    setEditedContent: any;
    isEditing: boolean;
}

const Audios: React.FC<AudiosProps> = (
    {
        offset,
        iterObject,
        editedContent = null,
        setEditedContent = null,
        isEditing
    }) => {
    const handleRemoveAudio = (index: number) => {
        const updatedContent = [...editedContent];
        updatedContent.splice(index, 1);
        setEditedContent(updatedContent);
    };

    return (
        <>
            {iterObject.length > 0 && (
                <div className="bg-neutral-100 dark:bg-neutral-900 my-3 rounded-2xl border border-neutral-800 overflow-hidden">
                    <div className="flex overflow-x-auto">
                        {iterObject.map((item: any, index: number) => {
                            const audioIndex = offset + index;
                            return (
                                <div key={audioIndex} className="flex-none relative mx-auto">
                                    <Audio item={item}/>
                                    {isEditing && (
                                        <button
                                            className="absolute top-1.5 right-1.5 bg-red-800 text-white border-none rounded-full w-5 h-5 text-xs flex justify-center items-center cursor-pointer"
                                            onClick={() => handleRemoveAudio(audioIndex)}
                                        >
                                            &times;
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
};

export default Audios;
